export default function StatCard({ label, value, hint, icon: Icon, tone = "default", testId }) {
  const tones = {
    default: "bg-primary/10 text-primary",
    success: "bg-emerald-500/10 text-emerald-500",
    warning: "bg-amber-500/10 text-amber-500",
    danger: "bg-red-500/10 text-red-500",
  };
  return (
    <div
      className="rounded-xl border border-border bg-card p-5 flex items-start justify-between gap-4 hover:border-primary/40 transition-colors"
      data-testid={testId}
    >
      <div className="min-w-0">
        <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground font-medium">{label}</div>
        <div className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight mt-2 tabular-nums truncate">
          {value}
        </div>
        {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
      </div>
      {Icon && (
        <div className={`shrink-0 w-10 h-10 rounded-lg grid place-items-center ${tones[tone]}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
    </div>
  );
}
